import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Checkbox } from "primereact/checkbox";

import { Button, CalendarField, TextInputField } from "../../../helpers";

import PunchedProducts from "./PunchedProducts";

import { deletePOPunch, submitPOPunch } from "../../../services/api/poPunch";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { getProductName, getProductSpecification, getUOMStr, round } from "../../../utils";


const SubmitPOQuantity = (props) => {
    const { materialData, setIsLoading, getBuyerPO, setBuyerPO, setBuyerPOItems, buyerPO, buyerPOItems, poPunch, poPunchItems, isPunchDisable, poPunchCreatedUsers } = props

    const [selectedBuyerPOItemIds, setSelectedBuyerPOItemIds] = useState([])

    const usersData = useSelector(state => state.userDetails)
    const brandData = useSelector((state) => state.common.materialBrands)

    const dispatch = useDispatch()

    const handlePunchClick = async (buyerPO, buyerPOItems) => {
        setIsLoading(true)

        const relatedBuyerPOItems = buyerPOItems.map(eachBuyerPOItem => {
            let expectedDeliveryDate = new Date(buyerPO?.poProcessedDate)
            let expectedDelivery = expectedDeliveryDate.getDate() + parseInt(eachBuyerPOItem?.leadTime)
            expectedDeliveryDate.setDate(expectedDelivery)

            return { 
                buyerPOId : eachBuyerPOItem?.buyerPOId,
                buyerPOItemId : eachBuyerPOItem?.buyerPOItemId,
                buyerReqId : eachBuyerPOItem?.buyerReqId,
                buyerReqItemId : eachBuyerPOItem?.buyerReqItemId,
                fileNo : eachBuyerPOItem?.fileNo,
                docNo : eachBuyerPOItem?.docNo,
                punchQty : eachBuyerPOItem?.punchQty,
                expectedDeliveryDate: expectedDeliveryDate, 
                createdBy : usersData?.userId, 
                updatedBy : usersData?.userId 
            }
        })
        if (buyerPO?.poProcessedDate){
            const updatedBuyerPOItems = relatedBuyerPOItems.filter(eachBuyerPOItem => eachBuyerPOItem.punchQty > 0)
            if (updatedBuyerPOItems.length > 0) {
                let data = {
                    buyerPOId: buyerPO.buyerPOId,
                    buyerPO: {
                        buyerPOId : buyerPO?.buyerPOId,
                        buyerReqId : buyerPO?.buyerReqId,
                        fileNo: buyerPO?.fileNo,
                        docNo : buyerPO?.docNo,
                        poProcessedDate : buyerPO?.poProcessedDate,
                        shipAddrId: buyerPO?.shipAddrId,
                        pmBillAddrId: buyerPO?.pmBillAddrId,
                        createdBy : usersData?.userId, 
                        updatedBy : usersData?.userId
                    },
                    buyerPOItems: updatedBuyerPOItems,
                    poPunch : poPunch
                }
                if (window.confirm("Do You Want to Submit the Punch?")){
                    const response = await submitPOPunch(data)
                    if (response?.failure){
                        dispatch(raiseToast({severity:'error', summary: 'PO Punch', detail: response?.data?.error , life: 3000}))
                    }else {
                        dispatch(raiseToast({severity:'success', summary: 'Success', detail: "PO Punch is Done" , life: 3000}))
                        getBuyerPO()
                    }
                }
            } else {
                dispatch(raiseToast({severity:'error', detail: "Please Enter the Qty", life: 3000}))
            }
        }else{
            dispatch(raiseToast({severity:'error', detail: "Please Enter PO Processed Date", life: 3000}))
        }
        setBuyerPO(prevState => ({...prevState, poProcessedDate: ""}))
        setIsLoading(false)
    }

    const handleOnChange = (e, buyerPOItemId, availableQty) => {
        const updatedBuyerPOItems = buyerPOItems.map(eachBuyerPOItem => {
            if (eachBuyerPOItem.buyerPOItemId === buyerPOItemId){
                if (e.target.name === "punchQty"){
                    if (e.target.value <= availableQty){
                        return {...eachBuyerPOItem, [e.target.name] : e.target.value}
                    }else{
                        dispatch(raiseToast({severity:'error', detail: `Available Qty : ${availableQty} Only`, life: 3000}))
                        return {...eachBuyerPOItem, [e.target.name] : availableQty}
                    }
                }else{
                    return {...eachBuyerPOItem, [e.target.name] : e.target.value}
                }
            } else {
                return eachBuyerPOItem
            }
        })
        setBuyerPOItems(updatedBuyerPOItems)
    }

    const handleCheckBoxClick = (e) => {
        if (e.checked){
            const relatedBuyerPOItemIds = buyerPOItems.map(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId)
            setSelectedBuyerPOItemIds(relatedBuyerPOItemIds)
        } else {
            setSelectedBuyerPOItemIds([])
        }
    }

    const handleSelectClick = (buyerPOItemId) => {
        if (selectedBuyerPOItemIds.includes(buyerPOItemId)){
            const updatedBuyerPOItemIds = selectedBuyerPOItemIds.filter(eachBuyerPOItemId => eachBuyerPOItemId !== buyerPOItemId)
            setSelectedBuyerPOItemIds(updatedBuyerPOItemIds)
        } else {
            const updatedBuyerPOItemIds = [...selectedBuyerPOItemIds, buyerPOItemId]
            setSelectedBuyerPOItemIds(updatedBuyerPOItemIds)
        }
    }

    const handleApplyClick = () => {
        if (selectedBuyerPOItemIds?.length > 0){
            const updatedBuyerPOItems = buyerPOItems?.map((eachBuyerPOItem) => {
                let totalPunchedQty = 0
                poPunchItems.map(eachPOPunchItem => {
                    if (eachBuyerPOItem.buyerReqItemId === eachPOPunchItem.buyerReqItemId){
                        totalPunchedQty += eachPOPunchItem.punchQty
                    }
                })
                if (selectedBuyerPOItemIds?.includes(eachBuyerPOItem.buyerPOItemId)){
                    return {...eachBuyerPOItem, punchQty : round(eachBuyerPOItem?.bPOQty - totalPunchedQty)}
                } else {
                    return eachBuyerPOItem
                }
            })
            setBuyerPOItems(updatedBuyerPOItems)
            setSelectedBuyerPOItemIds([])
        }else{
            dispatch(raiseToast({severity:'error', detail: "Select PO Items", life: 3000}))
        }
    }

    const handleResetClick = () => {
        const updatedBuyerPOItems = buyerPOItems.map(eachBuyerPOItem => {
            return {...eachBuyerPOItem, poProcessedDate : "", punchQty : "" }
        })
        setBuyerPOItems(updatedBuyerPOItems)
        setSelectedBuyerPOItemIds([])
    }

    const handleProcessedDate = (e) => {
        const updatedBuyerPOItems = buyerPOItems.map(eachBuyerPOItem => {
            return {...eachBuyerPOItem, poProcessedDate : e.target.value }
        })
        setBuyerPO(prevState => ({...prevState, poProcessedDate : e.target.value}))
        setBuyerPOItems(updatedBuyerPOItems)
        setSelectedBuyerPOItemIds([])
    }

    const handlePOPunchDeleteClick = async (id) => {
        setIsLoading(true)

        if(window.confirm("Are you sure you want to delete this PO Punch")){
            const poPunchRes = await deletePOPunch(id)
            if(poPunchRes.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', detail: poPunchRes.data.error , life: 3000}))
            }else{
                dispatch(raiseToast({severity:'error', detail: 'PO Punch Deleted Successfully.', life: 3000}))
            }
            getBuyerPO()
            setIsLoading(false)
            // handleUpdatedPOPunch(poPunchRes.data)
        }
        setIsLoading(false)
    }

    let activePOPunches = poPunch?.filter(eachPOPunch => eachPOPunch?.statusId === 1)
    let activePOPunchItems = poPunchItems?.filter(eachPOPunchItem => eachPOPunchItem?.statusId === 1)
    
    return (
        <div className="submit-po-quantity-tab">
            {/* <div className="flex flex-row justify-content-between mt-2">
                <div className="flex flex-row">
                    <div className="mr-3">
                        <Button className="small-btn" label="Apply" disabled={isPunchDisable} onClick={handleApplyClick}/>
                    </div>
                    <div className="">
                        <Button className="small-btn" label="Reset All" disabled={isPunchDisable} onClick={handleResetClick}/>
                    </div>
                </div>
            </div>
            <div className="p-card mt-3 py-1">
                <div className="flex flex-wrap py-2 w-full">
                    <div className="flex justify-content-between flex-grow-1 font-bold  header-style align-items-center " style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                        <div className="mb-2" style={{ width: '2%' }}>
                            <Checkbox onChange={e => handleCheckBoxClick(e)} disabled={isPunchDisable} checked={selectedBuyerPOItemIds.length === buyerPOItems.length}></Checkbox>
                        </div>
                        <div className="mb-2" style={{ width: '3%' }}>Sr No</div>
                        <div className="mb-2" style={{ width: '6%' }}>Material Id</div>
                        <div className="mb-2" style={{ width: '18%' }}>Product</div>
                        <div className="mb-2" style={{ width: '30%' }}>Specifications</div>
                        <div className="mb-2" style={{ width: '5%' }}>Total Qty</div>
                        <div className="mb-2" style={{ width: '10%' }}>Ttl Punched Qty</div>
                        <div className="mb-2" style={{ width: '7%' }}>Input Qty</div>
                        <div className="mb-2" style={{ width: '5%' }}>Delivery Period</div>
                        <div className="mb-2" style={{ width: '10%' }}>Expected Delivery Date</div>
                    </div>
                    {
                        buyerPOItems?.map((eachBuyerPOItem, index) => {
                            let totalPunchedQty = 0
                            const relatedMaterialData = materialData?.find(eachMaterial => eachMaterial.materialId === eachBuyerPOItem.materialId)
                            const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === relatedMaterialData?.brandId)

                            poPunchItems.map(eachPOPunchItem => {
                                if (eachBuyerPOItem.buyerReqItemId === eachPOPunchItem.buyerReqItemId && eachPOPunchItem.statusId === 1){
                                    totalPunchedQty += eachPOPunchItem.punchQty
                                }
                            })
                            let expectedDeliveryDate = new Date(eachBuyerPOItem?.poProcessedDate)
                            let expectedDelivery = expectedDeliveryDate.getDate() + parseInt(eachBuyerPOItem?.leadTime)
                            expectedDeliveryDate?.setDate(expectedDelivery)

                            let productName = getProductName(relatedBrand?.brandName, relatedMaterialData?.productName, relatedMaterialData?.variantName) // relatedMaterialData?.companyProdName ? relatedMaterialData?.companyProdName : relatedMaterialData?.productName
                            let productSpecification = getProductSpecification(relatedMaterialData?.productSpecification, relatedMaterialData.UOM, relatedMaterialData.UOMValue) // relatedMaterialData?.companyProdSpec ? relatedMaterialData?.companyProdSpec : relatedMaterialData?.productSpecification

                            return (
                                <div className="flex justify-content-between flex-grow-1 w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize:"13px" }}>
                                    <div className="py-1 align-self-center" style={{ width: '2%' }}>
                                        <Checkbox onChange={e => handleSelectClick(eachBuyerPOItem.buyerPOItemId)} disabled={eachBuyerPOItem?.bPOQty === totalPunchedQty} checked={selectedBuyerPOItemIds.includes(eachBuyerPOItem.buyerPOItemId)}></Checkbox>
                                    </div>
                                    <div className="py-1 align-self-center" style={{ width: '3%' }}>{index+1}</div>
                                    <div className="py-1 align-self-center" style={{ width: '8%' }}>{eachBuyerPOItem?.materialId}</div>
                                    <div className="py-1 align-self-center" style={{ width: '18%' }}>{productName}</div>
                                    <div className="py-1 align-self-center" style={{ width: '30%' }}>{productSpecification} - {getUOMStr(relatedMaterialData?.UOM, relatedMaterialData?.UOMValue)}</div>
                                    <div className="py-1 align-self-center" style={{ width: '5%' }}>{eachBuyerPOItem?.bPOQty}</div>
                                    <div className="py-1 align-self-center" style={{ width: '10%' }}>{totalPunchedQty}</div>
                                    <div className="py-1 align-self-center" style={{ width: '7%' }}>
                                        <TextInputField name="punchQty" disabled={eachBuyerPOItem?.bPOQty === totalPunchedQty} value={eachBuyerPOItem?.punchQty} onChange={e => handleOnChange(e, eachBuyerPOItem.buyerPOItemId, round(eachBuyerPOItem?.bPOQty - totalPunchedQty))}/>
                                    </div>
                                    <div className="py-1 align-self-center" style={{ width: '5%' }}>{eachBuyerPOItem?.leadTime} days</div>
                                    <div className="py-1 align-self-center" style={{ width: '10%' }}>{`${eachBuyerPOItem?.poProcessedDate ? new Date(expectedDeliveryDate).toLocaleDateString() : "-" }`}</div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="flex flex-row justify-content-end">
                <div>
                    <CalendarField name="poProcessedDate" minDate={new Date(buyerPO?.poReceivedDate)} maxDate={new Date()} disabled={isPunchDisable} value={buyerPO?.poProcessedDate} labelText="PO Processed Date" placeholder="" onChange={e => handleProcessedDate(e)}/>
                </div>
                <div className="ml-3 mt-3">
                    <Button applyThrottle label="Punch" disabled={isPunchDisable || buyerPO?.statusId === 6}  permissions={[12]}  onClick={() => handlePunchClick(buyerPO, buyerPOItems)}/>
                </div>
            </div> */}
            
            { activePOPunches?.length > 0 && 
                <> 
                    <div className="mt-1">
                        <PunchedProducts buyerPOItems={buyerPOItems} materialData={materialData} poPunch={activePOPunches} poPunchItems={activePOPunchItems} buyerPO={buyerPO} poPunchCreatedUsers={poPunchCreatedUsers} handlePOPunchDeleteClick={handlePOPunchDeleteClick} />
                    </div>
                </>
            }
        </div>
    )
}

export default SubmitPOQuantity;